import { api } from '../api/client';
import { unwrap } from '../api/api-error';
import { ensureOk } from '../auth/session';

type Meta = { name: string; description?: string | null };

/** Действия со схемами домашнего экрана (docs/architecture.md §7.4). */
export function homeCommands(workspaceId: string) {
  return {
    async create(body: Meta) {
      return unwrap(
        await api.POST('/api/v1/workspaces/{workspaceId}/diagrams', {
          params: { path: { workspaceId } },
          body,
        }),
      );
    },
    async update(diagramId: string, body: Meta) {
      return unwrap(
        await api.PATCH('/api/v1/workspaces/{workspaceId}/diagrams/{diagramId}', {
          params: { path: { workspaceId, diagramId } },
          body,
        }),
      );
    },
    /** Копия с теми же карточками и связями; версии и чаты не копируются. */
    async duplicate(diagramId: string, body: Meta) {
      return unwrap(
        await api.POST('/api/v1/workspaces/{workspaceId}/diagrams/{diagramId}/duplicate', {
          params: { path: { workspaceId, diagramId } },
          body,
        }),
      );
    },
    async remove(diagramId: string) {
      ensureOk(
        await api.DELETE('/api/v1/workspaces/{workspaceId}/diagrams/{diagramId}', {
          params: { path: { workspaceId, diagramId } },
        }),
      );
    },
  };
}
